// src/pages/LoginPage.tsx
import { Box } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import bgImage from "../asset/login_bg.jpeg";
import TradeShowCTA from "../components/Login/TradeShowText";
import { useAuth } from "../context/AuthContext";
import { AppDispatch, RootState } from "../store";
import { loginSuccess, PermissionMap, User } from "../store/slices/authSlice";
import { apiRequest } from "../utils/apiClient";

interface LoginResponse {
  token: string;
  user: User;
  permissions: PermissionMap;
  sessionExpiresAt: number;
}
const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  if (isAuthenticated) {
    const redirectTo = location.state?.from?.pathname || "/";
    return <Navigate to={redirectTo} replace />;
  }

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await apiRequest<LoginResponse>(
  "/api/auth/login",
  "POST",
  {
    email,
    password,
  },
);
      const { data }: any = response;
      // console.log("Response:    ", response);
      if (!data) {
        setErrorMessages(["Can not find User"]);
        return;
      }
      if (response.status !== 200) {
        setErrorMessages(["Invalid credentials"]);
        return;
      }
      const userData = {
        email: data?.user.email,
        username: data?.user.username,
        user_id: data?.user.user_id,
        role: data?.user.role,
        category: data?.user.category,
        first_name: data?.user.first_name,
        last_name: data?.user.last_name,
        location: data?.user.location,
        discount_percent: data?.user.discount_percent,
      };
      // Dispatch login success action with correctly typed data
      dispatch(
        loginSuccess({
          user: response.data.user,
          token: response.data.token,
          permissions: response.data.permissions,
          sessionExpiresAt: response.data.sessionExpiresAt,
        }),
      );
      alert("Login successful!");
      navigate("/");
    } catch (err) {
      // Handle error more explicitly with correct typing
      if (err) {
        console.error("Error response:", err);
        setError("Invalid credentials");
      } else {
        console.error("Unknown error:", err);
        setError("An unexpected error occurred");
      }
    }
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: `calc(100vh - 13vh)`,
        paddingTop: "3vh",
      }}
    >
      <TradeShowCTA />
      {/* <Box
        sx={{
          maxWidth: { xs: "250px", sm: "400px" },
          margin: "0 auto",
          padding: 3,
          filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)) ",
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          WebkitBackdropFilter: "blur(10px)", // for Safari
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
          Login
        </Typography>
        {error && <Typography color="error">{error}</Typography>}
        <form onSubmit={handleLogin}>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            fullWidth
            sx={{ marginTop: 2 }}
          >
            Login
          </Button>
        </form>
        {errorMessages.length > 0 && (
          <Grid size={12}>
            <Box sx={{ color: "red", marginBottom: 1 }}>
              {errorMessages.map((msg, index) => (
                <Typography key={index}>{msg}</Typography>
              ))}
            </Box>
          </Grid>
        )}
      </Box> */}
    </Box>
  );
};

export default LoginPage;
